import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APIRequestResources, APIRequest } from 'src/app/core';

export interface UpdateShiftTimeDTO {
  shiftId: number;
  machineId: number;
  startTime: string;
  endTime: string;
}

@Injectable({
  providedIn: 'root'
})
export class ShiftTimeService extends APIRequest {

  constructor(protected override http: HttpClient, private router: Router) {
    super(http, APIRequestResources.ShiftTimeService);
  }

  updateMachineTime(dto: UpdateShiftTimeDTO) {
    const options = {
      params: {
        shift_id: dto.shiftId,
        machine_id: dto.machineId,
        start_time: this.formatTime(dto.startTime),
        end_time: this.formatTime(dto.endTime)
      }
    };
    return this.patch<any>(null, options);
  }

  /** Ensures time is always HH:mm:ss — input[type=time] returns HH:mm */
  private formatTime(time: string): string {
    if (!time) return '';
    return time.length === 5 ? `${time}:00` : time;
  }
}
